import { render, staticRenderFns } from "./AddItemBrain.vue?vue&type=template&id=456f271a"
import script from "./AddItemBrain.vue?vue&type=script&lang=js"
export * from "./AddItemBrain.vue?vue&type=script&lang=js"
import style0 from "./AddItemBrain.vue?vue&type=style&index=0&id=456f271a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports